// Trade codes come from the backend; their labels are translated here (dashboard namespace).
export const TRADE_LABELS = {
  ELEKTRO: "Electrical",
  SHK: "Plumbing, heating, air conditioning",
  DACHDECKER: "Roofing",
  MALER: "Painting and decorating",
  TROCKENBAU: "Drywall",
  SCHREINER: "Carpentry / joinery",
  BODENLEGER: "Flooring",
  FLIESENLEGER: "Tiling",
  FENSTERBAU: "Windows",
  GEBAEUDEREINIGUNG: "Building cleaning",
  GALABAU: "Landscaping",
  BAU_ALLGEMEIN: "General construction"
};

export const SOURCE_LABELS = {
  doe: "Public tenders (DÖE)",
  ted: "EU tenders (TED)",
  blauarbeit: "Private requests (Blauarbeit)"
};

export const SOURCE_SHORT = { doe: "DÖE", ted: "TED", blauarbeit: "Blauarbeit" };

export const GRADE_LABELS = {
  MEISTER: "Master craftsman",
  GESELLE: "Journeyman",
  HELFER: "Helper",
  AZUBI: "Apprentice"
};

export const BAND_COLORS = {
  EXCELLENT: "#237804",
  GOOD: "#389e0d",
  POSSIBLE: "#d48806",
  POOR: "#cf1322"
};

export const DAY_MS = 86400000;

export const formatEuro = (value, lng) =>
  value === null || value === undefined
    ? "–"
    : new Intl.NumberFormat(lng || "de", { style: "currency", currency: "EUR" }).format(value);

export const formatDate = (value, lng, withTime) =>
  value
    ? new Intl.DateTimeFormat(
        lng || "de",
        withTime ? { dateStyle: "medium", timeStyle: "short" } : { dateStyle: "medium" }
      ).format(new Date(value))
    : "–";

export const daysLeft = deadline =>
  deadline ? Math.floor((new Date(deadline).getTime() - Date.now()) / DAY_MS) : null;

// A postcode-centre estimate is only good to about 30 km; below that, a number would be false precision.
export const formatDistance = lead =>
  lead.locationApproximate || lead.locationFromBuyer
    ? lead.distanceKm < 30
      ? "< 30 km"
      : `~${lead.distanceKm} km`
    : `${lead.distanceKm} km`;
